import React from 'react';
import './i18n';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Map from './components/Map';
import QuoteRequestForm from './components/QuoteRequestForm';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <About />
        <Contact />
        <QuoteRequestForm />
        <Map />
      </main>
      <Footer />
    </div>
  );
}

export default App; 